var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEbay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 85,
    fontFamily: "Arial, sans-serif",
    fontSize: 80,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#E53238"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#0064D2"
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#F5AF02"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#86B817"
  }, "y"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbay);
export default __webpack_public_path__ + "static/media/ebay.dc3c2455eb8348158caa07ef795e7cfc.svg";
export { ForwardRef as ReactComponent };